import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  /* .card {
    width: 714px;
    margin: auto;
  } */
`;
